import { GoogleMark } from './icons'
import { useAuth } from '../lib/auth'

export function SignInScreen() {
  const { signIn, error } = useAuth()
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-8 px-8">
      <Wordmark />
      <div className="flex flex-col items-center gap-3">
        <button
          type="button"
          onClick={() => void signIn()}
          className="flex items-center gap-2.5 rounded-xl border border-line-strong bg-surface px-5 py-3 text-[15px] font-medium transition-transform duration-150 ease-[var(--ease-out-quick)] active:scale-[0.98]"
        >
          <GoogleMark />
          Continue with Google
        </button>
        {error ? <p className="text-[13px] text-danger">{error}</p> : null}
      </div>
      <p className="max-w-[15rem] text-center text-[12px] leading-relaxed text-faint">
        Your time log is yours alone. Signing in creates a workspace only that account
        can read or write.
      </p>
    </div>
  )
}

export function Wordmark() {
  return (
    <div className="flex items-center gap-3">
      <img src="/favicon.svg" alt="" width={36} height={36} className="rounded-lg" />
      <span className="text-[21px] font-semibold tracking-tight">TimeGrid</span>
    </div>
  )
}
